import React, { useState } from "react";
import {
  CircularGauge,
  Scale,
  Label,
  RangeContainer,
  Range,
  ValueIndicator,
  Title,
} from "devextreme-react/circular-gauge";
import "./CreditGauge.css";

interface SectorRow {
  sector: string;
  EL: string;
  EAD: string;
  perc: string;
}

const CreditGauge: React.FC = () => {
  const [showTable, setShowTable] = useState<boolean>(true);

  // Gauge value (mocked)
  const gaugeValue: number = 0;

  // Table data (mocked from screenshot)
  const sectorData: SectorRow[] = [
    { sector: "Total", EL: "0", EAD: "0", perc: "0" },
    { sector: "Agriculture", EL: "0", EAD: "0", perc: "0" },
    { sector: "Accommodation and Food Services", EL: "0", EAD: "0", perc: "0" },
    { sector: "Retail", EL: "0", EAD: "0", perc: "0" },
    { sector: "Energy & Commodities", EL: "0", EAD: "0", perc: "0" },
    { sector: "Transportation & Airlines", EL: "0", EAD: "0", perc: "0" },
    { sector: "Financial institutions", EL: "0", EAD: "0", perc: "0" },
    { sector: "CFP Internal", EL: "0", EAD: "0", perc: "0" },
    { sector: "Construction", EL: "0", EAD: "0", perc: "0" },
    { sector: "Basic Materials/Industrials", EL: "0", EAD: "0", perc: "0" },
    { sector: "Check", EL: "0", EAD: "0", perc: "0" },
  ];

  return (
    <div className="sector-dashboard">
      {/* Gauge */}
      <h2 className="sector-title">Portfolio Breakdown by Sector</h2>
      <div className="sector-gauge-container">
        <CircularGauge value={gaugeValue} size={{ width: 400, height: 400 }}>
  <Scale startValue={0} endValue={160} tickInterval={20}>
    <Label customizeText={(arg: { value: number }) => `${Math.round((arg.value / 160) * 100)}%`} />
  </Scale>
  <RangeContainer>
    <Range startValue={0} endValue={60} color="#2ecc71" />
    <Range startValue={60} endValue={120} color="#f1c40f" />
    <Range startValue={100} endValue={160} color="#e74c3c" />
  </RangeContainer>
  <ValueIndicator type="triangleNeedle" color="#2c3e50" />
  <Title text="Gauge Reading (%)" />
</CircularGauge>
      </div>

      {/* Sector Breakdown */}
      <div className="sector-section">
        <div
          className="sector-section-header"
          onClick={() => setShowTable(!showTable)}
        >
          <h3 style={{ color: "black" }}>Limit statistics by FY</h3>
          <span style={{ color: "black" }}>{showTable ? "\u25B2" : "\u25BC"}</span>
        </div>

        {showTable && (
          <div className="sector-section-content">
            <p className="sector-highlight">Sector concentration (HHI): 0</p>
            <table className="sector-table">
              <thead>
                <tr>
                  <th>Sector</th>
                  <th>EL</th>
                  <th>EAD</th>
                  <th>% EAD</th>
                </tr>
              </thead>
              <tbody>
                {sectorData.map((row: SectorRow, idx: number) => (
                  <tr key={idx}>
                    <td
                      className={
                        row.sector === "Total" ? "sector-bold" : ""
                      }
                    >
                      {row.sector}
                    </td>
                    <td>{row.EL}</td>
                    <td>{row.EAD}</td>
                    <td>{row.perc}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default CreditGauge;
